import { SubscriptionDescriptionState } from "@/types/store/clientzone";
import { SubscriptionDescriptionsData } from "@/types";

export const state: SubscriptionDescriptionState = {
  subscriptionDescriptions: [] as Array<SubscriptionDescriptionsData>
}
